var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.invitation
    ? _c("div", [
        _c(
          "div",
          { staticClass: "header bg-gradient-success py-7 py-lg-8 pt-lg-9" },
          [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "header-body text-center mb-7" }, [
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-xl-5 col-lg-6 col-md-8 px-5" },
                    [
                      _c("div", {
                        staticClass: "logo-center text-center pb-4",
                      }),
                      _c("h1", { staticClass: "text-white" }, [
                        _vm._v(
                          "\n              Hello " +
                            _vm._s(_vm.invitation.invitedTo.firstName) +
                            "\n              " +
                            _vm._s(_vm.invitation.invitedTo.lastName) +
                            "\n            "
                        ),
                      ]),
                      _c("p", { staticClass: "text-lead text-white" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.invitation.invitedBy.firstName) +
                            "\n              " +
                            _vm._s(_vm.invitation.invitedBy.lastName) +
                            " has invited you to Join\n              "
                        ),
                        _c("br"),
                      ]),
                      _c("h3", { staticClass: "text-white" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.invitation.parent
                                ? _vm.invitation.parent.name + " / "
                                : ""
                            )
                          ),
                        ]),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.invitation.project.name)),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "separator separator-bottom separator-skew zindex-100",
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      x: "0",
                      y: "0",
                      viewBox: "0 0 2560 100",
                      preserveAspectRatio: "none",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("polygon", {
                      staticClass: "fill-default",
                      attrs: { points: "2560 0 2560 100 0 100" },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "container mt--8 pb-5" }, [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c("div", { staticClass: "col-lg-6 col-md-8" }, [
              _c("div", { staticClass: "w-100 h-100 flex-box bg-secondary" }, [
                _c("div", { staticClass: "card bg_disabled" }, [
                  _c("div", {
                    staticClass:
                      "card-header bg-transparent border-0 align-items-stretch w-100",
                  }),
                  _c("div", { staticClass: "card-body" }, [
                    _vm._m(0),
                    _c(
                      "form",
                      { attrs: { role: "form" } },
                      [
                        _c("base-input", {
                          staticClass: "mb-3",
                          attrs: {
                            alternative: "",
                            "prepend-icon": "ni ni-single-02",
                            placeholder: "First Name",
                          },
                          model: {
                            value: _vm.firstname,
                            callback: function ($$v) {
                              _vm.firstname = $$v
                            },
                            expression: "firstname",
                          },
                        }),
                        _vm.$v.firstname.$error
                          ? _c("div", { staticClass: "error field" }, [
                              _vm._v(
                                "\n                  First Name is required\n                "
                              ),
                            ])
                          : _vm._e(),
                        _c("base-input", {
                          staticClass: "mb-3",
                          attrs: {
                            alternative: "",
                            "prepend-icon": "ni ni-single-02",
                            placeholder: "Last Name",
                          },
                          model: {
                            value: _vm.lastname,
                            callback: function ($$v) {
                              _vm.lastname = $$v
                            },
                            expression: "lastname",
                          },
                        }),
                        _vm.$v.lastname.$error
                          ? _c("div", { staticClass: "error field" }, [
                              _vm._v(
                                "\n                  Last Name is required\n                "
                              ),
                            ])
                          : _vm._e(),
                        _c("base-input", {
                          staticClass: "mb-3",
                          attrs: {
                            alternative: "",
                            "prepend-icon": "ni ni-email-83",
                            placeholder: "Email",
                          },
                          model: {
                            value: _vm.email,
                            callback: function ($$v) {
                              _vm.email = $$v
                            },
                            expression: "email",
                          },
                        }),
                        _vm.$v.email.$error
                          ? _c("div", { staticClass: "error field" }, [
                              _vm._v(
                                "\n                  Valid email is required\n                "
                              ),
                            ])
                          : _vm._e(),
                        _c("base-input", {
                          staticClass: "mb-3",
                          attrs: {
                            alternative: "",
                            "prepend-icon": "ni ni-lock-circle-open",
                            type: "password",
                            placeholder: "Password",
                          },
                          model: {
                            value: _vm.password,
                            callback: function ($$v) {
                              _vm.password = $$v
                            },
                            expression: "password",
                          },
                        }),
                        _vm.$v.password.$error
                          ? _c("div", { staticClass: "error field" }, [
                              _vm._v(
                                "\n                  Password is required\n                "
                              ),
                            ])
                          : _vm._e(),
                        _c("base-input", {
                          staticClass: "mb-3",
                          attrs: {
                            alternative: "",
                            "prepend-icon": "ni ni-lock-circle-open",
                            type: "password",
                            placeholder: "Confirm Password",
                          },
                          model: {
                            value: _vm.confirm,
                            callback: function ($$v) {
                              _vm.confirm = $$v
                            },
                            expression: "confirm",
                          },
                        }),
                        _vm.$v.confirm.$required == false
                          ? _c("div", { staticClass: "error field" }, [
                              _vm._v(
                                "\n                  Confirm password is required\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm.$v.confirm.sameAsPassword == false
                          ? _c("div", { staticClass: "error field" }, [
                              _vm._v(
                                "\n                  Confirm should match with password\n                "
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "base-button",
                              {
                                staticClass: "my-4 btn-block",
                                attrs: { type: "primary" },
                                on: { click: _vm.handleRegistration },
                              },
                              [_vm._v("Complete")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("p", [
        _c("b", [_vm._v("We need few details to create your account")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }